// Resets the value carriers a plain input sweep cannot reach when a form block
// is cloned.
//
// Common::TimeFieldComponent and Common::DateFieldComponent render TWO inputs:
// a nameless visible <input type="text"> the picker writes into, and a hidden
// companion carrying the value under the real form field name. Clearing only
// the visible one leaves the clone looking empty while it still submits the
// source block's value — silently, and past any required-field validation.
//
// Only the picker targets are cleared, never every hidden input: Rails renders
// a hidden "0" companion before each check_box, and wiping those would break
// unchecked values.
const PICKER_VALUE_SELECTOR = [
  "input[type='hidden'][data-time-picker-target='value']",
  "input[type='hidden'][data-date-picker-target='value']",
].join(", ")

export function clearPickerValueInputs(root) {
  root.querySelectorAll(PICKER_VALUE_SELECTOR).forEach((input) => {
    input.value = ""
  })
}
